module.exports = "<h3 class=\"recipeDetail-videoTitle\">Video</h3>\r\n\r\n<div class=\"recipeDetail-videoContainer\">\r\n    <iframe class=\"recipeDetail-video\" ng-src=\"{{$ctrl.trustedUrl}}\" frameborder=\"0\"></iframe>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/recipe/recipedetail/recipe-detail-video.component.html
// module id = 103
// module chunks = 0 2